import React, { useEffect, useContext }from "react";
import useForm from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { makeStyles } from "@material-ui/core/styles";
import TextField from '@material-ui/core/TextField';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import Checkbox from "@material-ui/core/Checkbox";
import FormHelperText from "@material-ui/core/FormHelperText";
import { SessionContext } from "beaktShared/services/session";

// icons
import PersonIcon from '@material-ui/icons/Person';
import Check from "@material-ui/icons/Check";
import CircularProgress from '@material-ui/core/CircularProgress';

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Clearfix from "beaktShared/components/Clearfix/Clearfix.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import {ValidSelect} from "beaktShared/helpers/validselect";
import Select from 'react-select';
import {MaskDate, MaskLogin, validaLogin} from "beaktShared/helpers/masks";
import SnackbarContent from "beaktShared/components/Snackbar/SnackbarContent.js";
import Funcionalidades from "beaktShared/views/Seguranca/ListaFuncionalidades"

// services
import { UseGetApiSimple } from "beaktShared/services/crudeApiService";

import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
const useStyles = makeStyles(styles);

export default function UsuarioForm({ addItem, item, handleView, loading }) {
    const { t } = useTranslation(); 
    const session = useContext(SessionContext);
    const classes = useStyles();
    const { register, handleSubmit, setValue, setError, errors, clearError, getValues } = useForm({mode: "onChange"});    
    const [notification, setNotification] = React.useState({
        show:false,
        color:'info',
        message:''
    });
    const showNotification = (message,color) => { 
        setNotification({
        show:true,
        color:color,
        message:message      
        });
        setTimeout(function() {
        setNotification({show:false});
        }, 6000);       
    };
    const [loadingForm,setloadingForm] = React.useState(false);
    const [disableInputs, setdisableInputs] = React.useState(false);
    
    const [ativoCheckbox, setAtivoCheckbox] = React.useState(true);
    const [acessoEstabelecimentosAll, setacessoEstabelecimentosAll] = React.useState(false);
    
    const [acessaAppRecebimentoCheckbox, setacessaAppRecebimentoCheckbox] = React.useState(false);


    const [disabledTipoPerfil, setdisabledTipoPerfil] = React.useState(false);    
    const [tipoPerfilOptions, settipoPerfilOptions] = React.useState([]);    
    const [tipoPerfilSelect, settipoPerfilSelect] = React.useState(0);     
    const handleTipoPerfilChange = (event) => {
        settodasPermissoes(false);
        setpermissoesAcesso([]);
        let value = event
        settipoPerfilSelect(value);
        setValue("tipoperfil", value);
        if (value !== "")
            clearError("tipoperfil");
    }
    useEffect(() => {
        if (tipoPerfilSelect === 1 && session.estabelecimentoId == 0)
            LoadSelectEstabelecimentos();
        else
            setvisibleEstabelecimentos(false);
    }, [tipoPerfilSelect])    

    const [visibleEstabelecimentos, setvisibleEstabelecimentos] = React.useState(false);
    const [estabelecimentos, setestabelecimentos] = React.useState([]);
    const [listSelectEstabelecimentos, setlistSelectEstabelecimentos] = React.useState([]);    
    
    const LoadSelectEstabelecimentos = () =>{           
        setloadingForm(true);
        const endPoint = "estabelecimentos/byfranquia/"+session.franquiaId;
        UseGetApiSimple(endPoint,0).then(result=>{                   
            setloadingForm(false);
            if(result.status !== 200)
            {                                     
                showNotification(result.message,'danger');                                
                return false; 
            }                          
            setlistSelectEstabelecimentos(result.data);            
            setvisibleEstabelecimentos(true);
            return true;                
        });  
    }  
    
    const handleEstabelecimentoChange = event => {
        let value = event        
        let lstEstabelecimentosAdd = [];        
        value.map(item =>{
            lstEstabelecimentosAdd.push(item.estabelecimentoId);                                      
        });
        setestabelecimentos(lstEstabelecimentosAdd);                 
    };  
    
    const handleClickSelecionarTodosEstabelecimentos = event => {
        let data = getValues()
        let lstsAdd = [];        
        listSelectEstabelecimentos.map(item =>{
            lstsAdd.push(item.estabelecimentoId);                        
        });
        setestabelecimentos(lstsAdd);                
    }

    useEffect(() => {
        if (item.perfilUsuario != null && item.perfilUsuario.tipoPerfil == 1 && listSelectEstabelecimentos.length > 0){
            
            if(item.usuarioEstabelecimento!=null)
            {
                let estabelecimentosUsuario = []; 
                item.usuarioEstabelecimento.map((item) => estabelecimentosUsuario.push(item.estabelecimentoId));
                setestabelecimentos(estabelecimentosUsuario);
            }
        }        
    }, [listSelectEstabelecimentos])

    const getDescPerfil = (tipoPerfil) =>{
        let descPerfil = "";
        if(tipoPerfil == 0)    
            descPerfil = "Master";            
        else if(tipoPerfil == 1)    
            descPerfil = "Estabelecimento";         
        else if(tipoPerfil == 2)    
            descPerfil = "Profissional"; 
        else if(tipoPerfil == 3)    
            descPerfil = "Cliente";        
        else if(tipoPerfil == 4)    
            descPerfil = "Matriz";
        return descPerfil;
    }

    useEffect(() => {
        if (item.usuarioId != null) {    
            try {
                let descPerfil = getDescPerfil(item.perfilUsuario.tipoPerfil);
                tipoPerfilOptions.push({value: item.perfilUsuario.tipoPerfil, text: descPerfil});        
                settipoPerfilSelect(item.perfilUsuario.tipoPerfil);
            }
            catch {}
        }
        else if (session.estabelecimentoId != 0)
        {
            tipoPerfilOptions.push({value: 1, text: "Estabelecimento"});
            settipoPerfilSelect(1);
        }
        else if (session.franquiaId != 0){
            tipoPerfilOptions.push({value:4, text:"Matriz"});
            tipoPerfilOptions.push({value:1, text:"Estabelecimento"});            
        }        
        if (item.ativo != null)
            setAtivoCheckbox(item.ativo);

        if (item.acessaAppRecebimento != null)
            setacessaAppRecebimentoCheckbox(item.acessaAppRecebimento);
        
        try {
            setdisableInputs(false);
            if (session.tipoPerfil !== 4) 
            {
                if (item.perfilUsuario !== null)
                    if (item.perfilUsuario.tipoPerfil === 0)
                        setdisableInputs(true);
            }
        }
        catch 
        {
            try 
            {
                if (item.perfilUsuario !== null)
                    if (item.perfilUsuario.tipoPerfil === 0)
                        setdisableInputs(true);

            }
            catch 
            {
                setdisableInputs(false);
            }
        }

        if (tipoPerfilOptions.length > 1)
            setdisabledTipoPerfil(false);
        else
            setdisabledTipoPerfil(true);

        if (item.usuarioFranquia != null && item.usuarioFranquia.length > 0)
            setacessoEstabelecimentosAll(item.usuarioFranquia[0].acessaEstabelecimentos);
        
        if (item.usuarioPermissoesAcesso != null){
            if (item.perfilUsuario != null && item.perfilUsuario.tipoPerfil == 2 && session.estabelecimentoId != null){
                //permissao do estabelecimento prevalece sobre a legada (estabelecimentoId null) do mesmo path, igual a validacao de acesso da API
                let permissoesEstabelecimento = item.usuarioPermissoesAcesso.filter(f => f.estabelecimentoId == session.estabelecimentoId);
                let permissoesLegadas = item.usuarioPermissoesAcesso.filter(f => f.estabelecimentoId == null && permissoesEstabelecimento.filter(e => e.path == f.path).length == 0);
                setpermissoesAcesso([...permissoesEstabelecimento, ...permissoesLegadas]);
            }
            else{
                setpermissoesAcesso(item.usuarioPermissoesAcesso);
            }
        }            
        
        if (item.perfilUsuario != null && item.perfilUsuario.tipoPerfil == 1 && item.usuarioEstabelecimento !=null && item.usuarioEstabelecimento.length > 0)
        {
            let estabelecimentosUsuario = []; 
            item.usuarioEstabelecimento.map((item) => estabelecimentosUsuario.push(item.estabelecimentoId));
            setestabelecimentos(estabelecimentosUsuario);
        }        

    }, [item]);

    const [permissoesAcesso,setpermissoesAcesso] = React.useState([])
    const handleUsuarioPermissaoAcessoClick = (event) => {
        const data = event.target;
        let permissao = permissoesAcesso.filter((f) => f.path == data.name)[0];
        if (permissao == null){
            permissao = {                
                path: data.name,
                liberado: data.checked
            }
        }
        else{
            permissao.liberado = data.checked;
        }
        
        if (permissoesAcesso.filter((f) => f.path == data.name).length == 0)
            permissoesAcesso.push(permissao);
        
        let newPermissoes = permissoesAcesso.map(p => (p.path === permissao.path ? permissao : p));
        setpermissoesAcesso(newPermissoes);
    }
    const [todasPermissoes, settodasPermissoes] = React.useState(false);
    const handleClickSelecionarTodasPermissoes = (event) => {
        var funcionalidades = Funcionalidades.filter((funcionalidade) => funcionalidade.PerfilCod == tipoPerfilSelect)[0].Permissoes;
        let newPermissoes = [];
        for(var i in funcionalidades){        
            const data = funcionalidades[i];
            let permissao = permissoesAcesso.filter((f) => f.path == data.path)[0];
            if (permissao == null){
                permissao = {
                    path: data.path,
                    liberado: event.target.checked
                }
            }
            else{
                permissao.liberado = event.target.checked;
            }
            
            newPermissoes.push(permissao);                                                
        }        
        setpermissoesAcesso(newPermissoes);
        settodasPermissoes(event.target.checked);
    }

    const onSubmit = data => {  

        if (tipoPerfilSelect == 0){
            setError("tipoperfil","required", t('label.required'))
            return false;
        }

        if (visibleEstabelecimentos && estabelecimentos.length == 0){
            showNotification(t('label.required'),"warning")
            return false;
        }

        setloadingForm(true);
    
        
        let descPerfil = getDescPerfil(tipoPerfilSelect);
        let usuario = {
            usuarioId: data.id,
            login: validaLogin(data.login),
            nome: data.nome,
            email: data.email,            
            ativo: ativoCheckbox,            
            acessaAppRecebimento: acessaAppRecebimentoCheckbox,
            usuarioPermissoesAcesso: permissoesAcesso,
            perfilUsuario: {
                perfilUsuarioId: 0,
                tipoPerfil: tipoPerfilSelect
            }
        } 
        if (tipoPerfilSelect == 1){            
            usuario.usuarioEstabelecimento = [];
            if (session.estabelecimentoId !== 0)
            {
                usuario.usuarioEstabelecimento.push({
                    estabelecimentoId: session.estabelecimentoId
                });
            }
            else
            {
                for(var i in estabelecimentos){
                    usuario.usuarioEstabelecimento.push({
                        estabelecimentoId: estabelecimentos[i]
                    });
                }
            }
        }
        else if (tipoPerfilSelect == 4){
            if (item.usuarioFranquia != null)
            {
                usuario.usuarioFranquia = item.usuarioFranquia;
                usuario.usuarioFranquia[0].acessaEstabelecimentos = acessoEstabelecimentosAll;
            }
            else{
                usuario.usuarioFranquia = [];
                usuario.usuarioFranquia.push({
                    franquiaId: session.franquiaId,
                    acessaEstabelecimentos: acessoEstabelecimentosAll
                });
            }
        }
        addItem(usuario);   
        setloadingForm(false);     
    };

    const handleViewForm = () => {
        handleView();
    };

    return (
        <div className="maxContent">    
            {notification.show &&
                <div><br/>                
                <SnackbarContent
                    message={notification.message}
                    color={notification.color}
                    closeNotification={() => setNotification({show:false})}
                    close
            /></div>}                      
            <form onSubmit={handleSubmit(onSubmit)}>            
            <GridContainer>
                {loadingForm && 
                    <div className="carregandoCmp">
                        <div className="box">
                            <label>{t('label.loading')}</label>
                            <CircularProgress />
                        </div>
                    </div> 
                }
                <GridItem xs={12} sm={12} md={12}>
                    <Card>
                        <CardHeader color="primary" icon>
                            <CardIcon color="primary">
                                <PersonIcon />
                            </CardIcon>
                            <h4 className={classes.cardIconTitle}>
                                {t('information_message.user_registration')} - <small>{t('information_message.fill_in_the_user_data')}</small>
                                <input className={classes.hidden} defaultValue={item.usuarioId == null ? 0 : item.usuarioId} name="id" ref={register} />
                            </h4>
                        </CardHeader>
                        <CardBody>                            
                            <GridContainer>
                                <GridItem xs={12} sm={6} md={6}> 
                                    <FormControl fullWidth className={classes.formControl}>                               
                                    <TextField   
                                        disabled={disableInputs}
                                        error={errors.nome?true:false}
                                        label={t('label.name')+" *"}
                                        variant="outlined"                                    
                                        inputRef={register({required: true})}
                                        name="nome"                                        
                                        defaultValue={item.nome}  
                                        InputLabelProps={{shrink: true}}   
                                        inputProps={{maxLength: 100}}                          
                                    />
                                    <FormHelperText className={classes.labelRootError}>
                                        {errors.nome && <span>{t('label.required')}</span>}
                                    </FormHelperText>   
                                    </FormControl>                                 
                                </GridItem>
                                <GridItem xs={12} sm={6} md={6}> 
                                    <FormControl fullWidth className={classes.formControl}>                               
                                    <TextField    
                                        disabled={disableInputs}                                    
                                        error={errors.login?true:false}
                                        label={t('login.login')+" *"}
                                        variant="outlined"                                    
                                        inputRef={register({required: true})}
                                        name="login"
                                        defaultValue={item.login}
                                        onInput={(e) => MaskLogin(e)}
                                        onBlur={(e) => setValue("login", validaLogin(e.target.value))}
                                        InputLabelProps={{shrink: true}}
                                        inputProps={{maxLength: 150}}
                                    />
                                    <FormHelperText className={classes.labelRootError}>
                                        {errors.login && <span>{t('label.required')}</span>}
                                    </FormHelperText>   
                                    </FormControl>                                 
                                </GridItem>
                                <GridItem xs={12} sm={6} md={6}> 
                                    <FormControl fullWidth className={classes.formControl}>                               
                                    <TextField  
                                        disabled={disableInputs}                                      
                                        error={errors.email?true:false}
                                        label={t('label.email')+" *"}
                                        variant="outlined"                                    
                                        inputRef={register({required: true})}
                                        name="email"
                                        defaultValue={item.email}  
                                        InputLabelProps={{shrink: true}}   
                                        inputProps={{maxLength: 150}}                          
                                    />
                                    <FormHelperText className={classes.labelRootError}>
                                        {errors.email && <span>{t('label.required')}</span>}
                                    </FormHelperText>   
                                    </FormControl>                                 
                                </GridItem>
                                <GridItem xs={12} sm={6} md={3}> 
                                    <FormControl fullWidth className={classes.formControl}>
                                        <label className={errors.tipoperfil ? "select__label select__label_error" : "select__label"}>{t('sidebar.profile')+" *"}</label>
                                        <Select
                                            isDisabled={disabledTipoPerfil}
                                            classNamePrefix="select"
                                            styles={ValidSelect(errors.tipoperfil ? true : false)}
                                            isSearchable={true}                                            
                                            name="tipoperfil"       
                                            placeholder="Selecione"  
                                            value={tipoPerfilOptions.filter(({ value }) => value == tipoPerfilSelect)}          
                                            getOptionLabel={({ text }) => text}
                                            getOptionValue={({ value }) => value}
                                            options={tipoPerfilOptions}                                            
                                            onChange={(value) => handleTipoPerfilChange(value.value)}
                                            ref={() => register({ name: "tipoperfil" })
                                            }
                                        />
                                        {errors.tipoperfil &&
                                        <FormHelperText>
                                            <span className="obg">{t('label.required')}</span>
                                        </FormHelperText>}
                                    </FormControl>
                                </GridItem>                                
                                <GridItem xs={12} sm={12} md={4}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                disabled={disableInputs}
                                                tabIndex={-1}                                                
                                                checked={ativoCheckbox}   
                                                onClick={event => {setAtivoCheckbox(event.target.checked)}}
                                                checkedIcon={<Check className={classes.checkedIcon} />}
                                                icon={<Check className={classes.uncheckedIcon} />}
                                                classes={{
                                                    checked: classes.checked,
                                                    root: classes.checkRoot
                                                }}                    
                                                name="ativo"  
                                                inputRef={register}                                                    
                                            />
                                        }
                                        classes={{
                                            label: classes.label,
                                            root: classes.labelRoot
                                        }}
                                        label={t('information_message.system_active')}
                                    />
                                </GridItem>
                                {tipoPerfilSelect == 1 && 
                                    <GridItem xs={12} sm={12} md={4}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    disabled={disableInputs}
                                                    tabIndex={-1}                                                
                                                    checked={acessaAppRecebimentoCheckbox}   
                                                    onClick={event => {setacessaAppRecebimentoCheckbox(event.target.checked)}}
                                                    checkedIcon={<Check className={classes.checkedIcon} />}
                                                    icon={<Check className={classes.uncheckedIcon} />}
                                                    classes={{
                                                        checked: classes.checked,
                                                        root: classes.checkRoot
                                                    }}                    
                                                    name="acessaAppRecebimento"  
                                                    inputRef={register}                                                    
                                                />
                                            }
                                            classes={{
                                                label: classes.label,
                                                root: classes.labelRoot
                                            }}
                                            label={"Acessa App Recebimento"}
                                        />
                                    </GridItem>
                                    }
                                {(!visibleEstabelecimentos && session.estabelecimentoId == 0) && 
                                    <GridItem xs={12} sm={12} md={4}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    tabIndex={-1}                                                
                                                    checked={acessoEstabelecimentosAll}   
                                                    onClick={event => {setacessoEstabelecimentosAll(event.target.checked)}}
                                                    checkedIcon={<Check className={classes.checkedIcon} />}
                                                    icon={<Check className={classes.uncheckedIcon} />}
                                                    classes={{
                                                        checked: classes.checked,
                                                        root: classes.checkRoot
                                                    }}                    
                                                    name="acessaEstabelecimentos"  
                                                    inputRef={register}                                                    
                                                />
                                            }
                                            classes={{
                                                label: classes.label,
                                                root: classes.labelRoot
                                            }}
                                            label={t('information_message.access_all_establishments')}
                                        />
                                    </GridItem>
                                }
                                {visibleEstabelecimentos && 
                                    <GridItem xs={12} sm={12} md={12}>                                            
                                    <br/>
                                    <FormControl fullWidth className={classes.formControl}>
                                        <label className={"select__label"}>* {t('label.establishments')}</label>
                                        <Select
                                            classNamePrefix="select"                                                    
                                            isSearchable={true}
                                            isMulti={true}                                            
                                            name="estabelecimentos"
                                            placeholder= {t('label.select')+"..."}
                                            options={listSelectEstabelecimentos}                                                    
                                            getOptionLabel={({ descricao }) => descricao}
                                            getOptionValue={({ estabelecimentoId }) => estabelecimentoId}
                                            value={listSelectEstabelecimentos.filter(({estabelecimentoId}) => estabelecimentos.indexOf(estabelecimentoId) != -1)}
                                            onChange={(value) => handleEstabelecimentoChange(value || [])}
                                            ref={() => register({ name: "estabelecimentos" })
                                            }
                                        />
                                        </FormControl>
                                        <a href="#"  onClick={() => handleClickSelecionarTodosEstabelecimentos()} style={{marginTop:'10px'}}>
                                            {t('label.select_all_establishments')}
                                        </a>
                                    </GridItem>
                                }                                                               
                            </GridContainer>                            
                            <br/>
                            <div className="subTitulo"> 
                                <h6>{t('label.access_permissions')}</h6>
                            </div>
                            <GridContainer>                            
                                <GridItem xs={12} sm={12} md={12}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                tabIndex={-1}                                                
                                                checked={todasPermissoes}
                                                checkedIcon={<Check className={classes.checkedIcon} />}
                                                onClick={event => {handleClickSelecionarTodasPermissoes(event)}}
                                                icon={<Check className={classes.uncheckedIcon} />}
                                                classes={{
                                                    checked: classes.checked,
                                                    root: classes.checkRoot
                                                }}                    
                                                name="todaspermissoes"
                                                inputRef={register}                                                    
                                            />
                                        }
                                        classes={{
                                            label: classes.label,
                                            root: classes.labelRoot
                                        }}
                                        label={t('label.all_permissions')}
                                    />                                                            
                                </GridItem>
                                {tipoPerfilSelect != 0 &&
                                    Funcionalidades.filter((funcionalidade) => funcionalidade.PerfilCod == tipoPerfilSelect)[0].Permissoes.map((funcionalidade) => (
                                        <GridItem xs={12} sm={6} md={4} key={funcionalidade.path}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        tabIndex={-1}                                                
                                                        checked={permissoesAcesso.filter((f) => (f.path == funcionalidade.path && f.liberado == true)).length > 0 ? true : false}
                                                        checkedIcon={<Check className={classes.checkedIcon} />}
                                                        onClick={event => {handleUsuarioPermissaoAcessoClick(event)}}
                                                        icon={<Check className={classes.uncheckedIcon} />}
                                                        classes={{
                                                            checked: classes.checked,
                                                            root: classes.checkRoot
                                                        }}                    
                                                        name={funcionalidade.path}
                                                        inputRef={register}                                                    
                                                    />
                                                }
                                                classes={{
                                                    label: classes.label,
                                                    root: classes.labelRoot
                                                }}
                                                label={funcionalidade.name}
                                            />    
                                        </GridItem>
                                    ))
                                } 
                            </GridContainer>
                            <Clearfix />
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>
            <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={12} className={classes.textCenter}>
                    <div className={classes.textCenter}>
                        <Button  onClick={() => handleViewForm()} color="transparent" className={classes.updateProfileButton}>
                            {t('button.cancel')}
                        </Button>
                        <Button type="submit" color="primary" className={classes.updateProfileButton}>
                            {t('button.to_save')} 
                            {loading && <div> ... {t('label.loading')}</div>}
                        </Button>
                    </div>
                </GridItem>
            </GridContainer>            
            </form>
        </div>
    );
}